export default __webpack_public_path__ + "locales/de/FilesSettings.json?hash=d34873ca84c2ae9ed7d8f6289677ed5e";